/**
 * Verti DEU PL API
 *
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

/**
 * (german: Familienstand)     * `Single`          - german: ledig   * `Married`         - german: verheiratet   * `Divorced`        - german: geschieden   * `Widowed`         - german: verwitwet   * `LivingCommunity` - german: Lebensgemeinschaft   * `Other`           - german: sonstige
 */
export const MaritalStatus = {
  Single: 'Single',
  Married: 'Married',
  Divorced: 'Divorced',
  Widowed: 'Widowed',
  LivingCommunity: 'LivingCommunity',
  Other: 'Other',
} as const;
export type MaritalStatus = (typeof MaritalStatus)[keyof typeof MaritalStatus];
